import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-delete-confrim-modal',
  templateUrl: './delete-confrim-modal.component.html',
  styleUrls: ['./delete-confrim-modal.component.scss']
})
export class DeleteConfrimModalComponent implements OnInit {
public obj: any;
  public deleteRequest: Observable<any>;
  @Output() deleteConfirm: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('deleteConfirmModal') deleteConfirmModal;
  modalRef: NgbModalRef;
  constructor(private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,) {
  }

  open(request, obj=null) {
    this.deleteRequest = request;
    this.obj = obj;
    this.modalRef = this.modalService.open(this.deleteConfirmModal);
  }

  ngOnInit(): void {
  }

  close() {
    this.modalRef.close();
  }

  delete() {
    this.spinner.show();
    this.deleteRequest.subscribe(
      r => {
        this.spinner.hide();
        this.close();
        this.toastr.success('Deleted.', 'Success!');
        this.deleteConfirm.emit(this.obj);
      }, error => {
        this.spinner.hide();
      }
    )
  }
}
